// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ` .AvatarUpload-heading-PC2dv {
 	font-size: 36px;
 	font-weight: 600;
 	margin-bottom: 36px;
 	margin-top: 0;
 }

 .AvatarUpload-activationStepPanel-RJlWV {
 	max-width: 518px;
 	margin: 0 auto;
 	text-align: center;
 	padding-top: 73px;
 }

 .AvatarUpload-textLead-B6Dar {
 	font-size: 18px;
 	text-align: center;
 	margin-top: 12px;
 	margin-bottom: 24px;
 }

 @media screen and (max-width: 767px) {
 	.AvatarUpload-activationStepPanel-RJlWV {
 		padding: 73px 10px 0;
 	}
 }`, "",{"version":3,"sources":["webpack://./src/components/Booking/AvatarUpload/AvatarUpload.css"],"names":[],"mappings":"CAAC;EACC,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;CACd;;CAEA;EACC,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,iBAAiB;CAClB;;CAEA;EACC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;CACpB;;CAEA;EACC;GACC,oBAAoB;EACrB;CACD","sourcesContent":[" .heading {\n \tfont-size: 36px;\n \tfont-weight: 600;\n \tmargin-bottom: 36px;\n \tmargin-top: 0;\n }\n\n .activationStepPanel {\n \tmax-width: 518px;\n \tmargin: 0 auto;\n \ttext-align: center;\n \tpadding-top: 73px;\n }\n\n .textLead {\n \tfont-size: 18px;\n \ttext-align: center;\n \tmargin-top: 12px;\n \tmargin-bottom: 24px;\n }\n\n @media screen and (max-width: 767px) {\n \t.activationStepPanel {\n \t\tpadding: 73px 10px 0;\n \t}\n }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"heading": `AvatarUpload-heading-PC2dv`,
	"activationStepPanel": `AvatarUpload-activationStepPanel-RJlWV`,
	"textLead": `AvatarUpload-textLead-B6Dar`
};
module.exports = ___CSS_LOADER_EXPORT___;
